import type { Feature } from '@luna/gatekeeper';

export const cardLock: Feature = {
    enabled: true,
    _description:
        'Enables display of the refactored card lock focus page on lock card button click',
};
